import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  mnTemplates:state => state.mnTemplates,
  mnMultichannelTemplates:state => state.mnMultichannelTemplates,
  mnTemplateItem:state => state.mnTemplateItem,
  mnServices:state => state.mnServices,
  mnRoutesList:state => state.mnRoutesList,
};